import React from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { useTranslation } from 'react-i18next';
import {
  gridPanelFullscreenChanged,
  selectGridPanelMaximized,
  selectMaximizedStream,
} from 'features/layout/features/content/contentSlice';
import { useSystemSession } from 'hooks/useSystemSession';
import { GridPanelControl } from 'features/layout/grid-panel/GridPanelControl';
import {
  selectCustomTilesCount,
  selectHideLayoutControls,
} from 'features/layout/features/config/configSlice';
import { selectPageStreams } from 'features/layout/features/pagination/paginationSlice';
import { useBreakpoints } from 'hooks/useBreakpoints';
import { usePiPWindow } from 'components/PiP/PiPProvider';

export const useGridPanelFullscreenControl = () => {
  const maximized = useAppSelector(selectGridPanelMaximized);
  const hideLayoutControls = useAppSelector(selectHideLayoutControls);
  const streams = useAppSelector(selectPageStreams);
  const customTilesCount = useAppSelector(selectCustomTilesCount);
  const maximizedStream = useAppSelector(selectMaximizedStream);

  const forcedExpand = !streams.length && !customTilesCount && !maximizedStream;

  const isSystemSession = useSystemSession();
  const { pipWindow } = usePiPWindow();
  const { isMobile } = useBreakpoints();

  const controlEnabled =
    !isMobile && !isSystemSession && !pipWindow && !hideLayoutControls && !forcedExpand;

  const { t } = useTranslation('room');

  const dispatch = useAppDispatch();

  const handleClick = () => {
    if (maximized) {
      dispatch(gridPanelFullscreenChanged(false));
    } else {
      dispatch(gridPanelFullscreenChanged(true));
    }
  };

  return {
    handleClick,
    controlEnabled,
    icon: maximized ? 'exit-fullscreen' : 'fullscreen',
    tooltip: maximized ? t('tooltips.minimize_content') : t('tooltips.expand_content'),
  };
};

export const GridPanelFullscreenControl = () => {
  const { icon, tooltip, controlEnabled, handleClick } = useGridPanelFullscreenControl();

  if (!controlEnabled) {
    return;
  }

  return <GridPanelControl icon={icon} onClick={handleClick} tooltip={tooltip} />;
};
